exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index-memory_container-gfDrO{width:110px;height:64px;opacity:.9;cursor:move;overflow:hidden;z-index:10000;position:absolute;-ms-user-select:none;user-select:none;-webkit-user-select:none;background-color:#020;padding:0;display:flex;flex-direction:column}.index-memory_container-gfDrO .index-close_icon-KdZ7q{width:16px;height:16px;padding:4px;float:right;cursor:default;margin-top:2px;margin-right:2px}.index-memory_container-gfDrO .index-memory_text-3GAS3{color:#0f0;font-size:9px;font-weight:700;line-height:15px;padding-left:10px;margin-top:2px}", ""]);

// Exports
exports.locals = {
	"memory_container": "index-memory_container-gfDrO",
	"close_icon": "index-close_icon-KdZ7q",
	"memory_text": "index-memory_text-3GAS3"
};